import i18next from 'i18next';

const I18N_KEY_PREFIX = '_common:entities.paymentMethod.items';

/**
 * Builds a translations lookup key so that the
 * different payment methods can resolve to the same label.
 * e.g. 'Visa' | 'VISA' | 'visa' -> 'visa', 'FLEX_PAY' | 'Flex Pay' -> 'flexpay'
 *
 * @param {string} value
 * @returns {string}
 */
function normalizeKey(value) {
    return String(value)
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '');
}

/**
 * Human readable fallback for payment method.
 * e.g. 'VISA' -> 'Visa'
 *
 * @param {string} value
 * @returns {string}
 */
function toTitleCase(value) {
    return String(value)
        .toLowerCase()
        .split(/[\s_-]+/)
        .filter(Boolean)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

/**
 * Maps a raw payment method to a human readable label for the end user.
 * e.g. 'visa' | 'Visa' -> 'Visa', 'FLEXPAY' -> 'Flex Pay'
 *
 * Flexpay is a known value handled by translations,
 * everything else falls back to a title-cased version of the raw value.
 *
 * @param {string} value - The raw payment method as returned by the API.
 * @returns {string} The human readable payment method, or 'N/A' when not provided.
 */
export default function paymentMethodFormat(value) {
    if (!value) {
        return 'N/A';
    }

    const key = `${I18N_KEY_PREFIX}.${normalizeKey(value)}`;

    if (i18next.exists(key)) {
        return i18next.t(key);
    }

    return toTitleCase(value);
}
